import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { QrReader } from 'react-qr-reader';
import { SearchQrCode } from "../../services/Coupon";
import { setShop } from "../../features/ShopSlice";
import ErrorPopup from "../../components/popup/ErrorPopup";
import { Dialog } from "@mui/material";
import SecondaryButton from "../../components/button/SecondaryButton";
import useWindowDimensions from "../../functions/getScreen";
import BarcodeScannerComponent from "react-qr-barcode-scanner";



export default function ShopScanQrCode() {
  const { height , width} = useWindowDimensions();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.shop)

  const [qrcode, setQrCode] = useState('No result');
  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('ไม่สามารถใช้คูปองได้');



  useEffect(() => {
  }, []);

  useEffect(() => {
    if (qrcode && qrcode !== 'No result') {
      getSearchQrCode()
    }
  }, [qrcode]);


  async function getSearchQrCode() {
    return await SearchQrCode({ data: { qrCode: qrcode, shopId: store['shopId'] } })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          fnSetData('qrCode', qrcode)
          navigate('/shop-coupon-confirm')
        } else {
          if (response.data.body.error === 'Shop not correct') {
            setErrorMessage('ไม่สามารถใช้คูปองที่สาขานี้ได้')
            setOpenCancelPopup(true)
          } else if (response.data.body.error === 'QR expired') {
            setErrorMessage('QR code หมดอายุแล้ว')
            setOpenCancelPopup(true)
          } else if (response.data.body.error === 'Coupon Used') {
            setErrorMessage('คูปองถูกใช้ไปแล้ว')
            setOpenCancelPopup(true)
          } else {
            setOpenErrorPopup(true)
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function ScanOverlay() {
    return (
      <svg viewBox="-10 -10 120 120" className="z-[1] relative" style={{
        boxSizing: 'border-box',
        border: '35px solid rgba(0, 0, 0, 0.3)'
      }}>
        <path fill="none" d="M13,0 L0,0 L0,13" stroke="rgb(196, 196, 196)" strokeWidth="2" />
        <path fill="none" d="M0,87 L0,100 L13,100" stroke="rgb(196, 196, 196)" strokeWidth="2" />
        <path fill="none" d="M87,100 L100,100 L100,87" stroke="rgb(196, 196, 196)" strokeWidth="2" />
        <path fill="none" d="M100,13 L100,0 87,0" stroke="rgb(196, 196, 196)" strokeWidth="2" />
      </svg>
    )
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setShop(tmpObj));
  }

  function handleError(err) {
    console.error(err)
  }

  return (
    <>
      <ErrorPopup
        open={openErrorPopup}
        actionFunction={() => {
          setOpenErrorPopup(false)
        }}
      />
      <Dialog open={openCancelPopup} fullWidth={true} maxWidth="xl">
        <div className="py-[24px] px-[23px] rounded-[4px]">
          <p className="text-[24px] font-bold text-center text-red">ขออภัย</p>
          <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">{errorMessage}</p>

          <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
            <SecondaryButton
              onClick={() => {
                setOpenCancelPopup(false)
              }}
              variant="outlined"
              className="w-[50%]"
            >
              ปิด
            </SecondaryButton>

          </div>

        </div >
      </Dialog >
      <div className="bg-black text-center" style={{ height: height }}>
        <div className="flex justify-items-start items-center">
          <div className="absolute flex text-white text-[20px] mb-7 ml-[18px]" onClick={() => navigate(-1)}>
            <p className="mr-[5px]">←</p>
            <p>ย้อนกลับ</p>
          </div>
          <div className="flex-1 mb-10 pt-5">
            <p className="text-lightBlue text-[28px]">ใช้คูปอง</p>
          </div>
        </div>
        <div className="text-[24px] text-white mb-4 mt-[40px]">
          วาง QR Code ให้อยู่ในพื้นที่ที่กำหนด
        </div>

        {/* <div className="mx-[30px]">
          <QrReader
            className="qr-read-tag"
            onResult={(result) => {
              if (!!result) {
                setQrCode(result?.text);
              }
            }}
            constraints={{ facingMode: 'environment' }}
            ViewFinder={ScanOverlay}
            videoContainerStyle={{ paddingTop: '0%', }}
            videoStyle={{ width: '100%' }}
          />

          <a className="text-white" href={qrcode} target="_blank">{qrcode}</a> 
        </div> */}
        <div className="mx-[30px]">
          <BarcodeScannerComponent
            videoStyle={{ width: '100%' }}
            height={width-60}
            onUpdate={(err, result) => {
              if (result) setQrCode(result?.text);
            }}
          />
        </div>




      </div>
    </>
  );
}
